/**
 * Admin Resource Types API Service (T059 - US5)
 * HTTP client for resource types CRUD endpoints
 */

import { apiClient } from '@/core/api/client';
import type {
  AdminResourceType,
  CreateResourceTypePayload,
  UpdateResourceTypePayload,
} from '../types/admin-resource.type';

const BASE_PATH = '/admin/resource-types';

type ListResponse = {
  data: AdminResourceType[];
  total: number;
};

export async function listResourceTypes(): Promise<AdminResourceType[]> {
  const response = await apiClient.get<ListResponse>(BASE_PATH);
  return response.data.data;
}

export async function createResourceType(
  payload: CreateResourceTypePayload,
): Promise<AdminResourceType> {
  const response = await apiClient.post<AdminResourceType>(BASE_PATH, payload);
  return response.data;
}

export async function updateResourceType(
  id: string,
  payload: Omit<UpdateResourceTypePayload, 'id'>,
): Promise<AdminResourceType> {
  const response = await apiClient.patch<AdminResourceType>(
    `${BASE_PATH}/${id}`,
    payload,
  );
  return response.data;
}

export async function deactivateResourceType(
  id: string,
): Promise<AdminResourceType> {
  const response = await apiClient.delete<AdminResourceType>(
    `${BASE_PATH}/${id}`,
  );
  return response.data;
}

export const adminResourceTypesApi = {
  listResourceTypes,
  createResourceType,
  updateResourceType,
  deactivateResourceType,
};
